// Config for the catalogue-derived home sections (HowItWorks, Testimonials,
// StatsBand). Pattern source: timeleft.com / 222.place section structures from
// the 2026-06-09 clone catalogue (aafrancis/inspiration-vault). All copy and
// visuals here are LetsLoop's own.
//
// PLACEHOLDER CONTENT: every number and quote below is illustrative, in the
// same spirit as SocialProofTicker's sample messages. Founder must replace
// with real values before this branch merges.

import type { LucideIcon } from "lucide-react";
import { PenLine, Users, MapPin, Star, CalendarHeart } from "lucide-react";

export interface HowItWorksStep {
  n: string;
  title: string;
  body: string;
  Icon: LucideIcon;
  // Must be a THEME TOKEN, not a literal hex. These grounds carry text-ink,
  // which flips to near-white in dark mode, so a fixed light hex leaves the
  // copy invisible on a cream card. Shipped that way on 2026-07-31.
  bg: string;
  rotate: string; // tailwind rotate class for the tilted-card look
}

export const howItWorksSteps: HowItWorksStep[] = [
  {
    n: "01",
    title: "Start a loop",
    body: "Got a plan? Put it out there in seconds: a coffee, a walk, a 6:30 kickabout. Say what, where and when, and it lands with people nearby.",
    Icon: PenLine,
    bg: "var(--color-paper-salmon)",
    rotate: "md:-rotate-2",
  },
  {
    n: "02",
    title: "Loop in",
    body: "Browse the loops happening around you and tap into whatever you fancy. Real names, real faces: see who's already in before you say yes.",
    Icon: Users,
    bg: "var(--color-paper-mint)",
    rotate: "md:rotate-1",
  },
  {
    n: "03",
    title: "Show up",
    body: "Turn up and meet people in real life. The plan comes first; the group chat follows, not the other way round.",
    Icon: MapPin,
    bg: "var(--color-paper-sand)",
    rotate: "md:-rotate-1",
  },
];

export interface Testimonial {
  quote: string;
  name: string;
  area: string;
  stars: number;
}

// HELD, not rendered (unwired from App.tsx 2026-06-21). Replace with real, consented
// member quotes, then re-add <Testimonials /> in App.tsx. Never ship fabricated quotes.
export const testimonials: Testimonial[] = [
  {
    quote:
      "I moved to London knowing two people. Three loops later my Sunday walk group is the most reliable part of my week.",
    name: "Maya",
    area: "Hackney",
    stars: 5,
  },
  {
    quote:
      "It never felt like networking. You just keep showing up to small things and suddenly you have people.",
    name: "Tom",
    area: "Battersea",
    stars: 5,
  },
  {
    quote:
      "Found my people here. Honestly, the group chat from our first loop is the thing I'd miss most.",
    name: "Priya",
    area: "Peckham",
    stars: 5,
  },
];

export interface Stat {
  value: string;
  label: string;
  sub: string;
  Icon: LucideIcon;
}

// HELD, not rendered (unwired from App.tsx 2026-06-21). Replace with real numbers, then
// re-add <StatsBand /> in App.tsx. Note: "average loop rating" cannot ship pre-launch
// (there is no rating yet). Never ship unverified stats.
export const stats: Stat[] = [
  {
    value: "1,200+",
    label: "On the waitlist",
    sub: "and counting",
    Icon: Users,
  },
  {
    value: "85+",
    label: "Loops posted",
    sub: "across London",
    Icon: CalendarHeart,
  },
  {
    value: "4.9",
    label: "Average loop rating",
    sub: "from early members",
    Icon: Star,
  },
];
